module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/pro/inventory/inventory-show/inventory-show.component.scss
// module id = ./src/app/views/pro/inventory/inventory-show/inventory-show.component.scss
// module chunks = main